import {
    Feature,
    FEATURE_QUERY_ENABLED,
    FEATURE_QUERY_VALUE,
    IFeatureQuery,
    IFeatureValue,
} from '@gig/magic-messages';
export { Feature } from '@gig/magic-messages';

/**
 * Used for backwards compatibility.
 */
export const DEFAULT_PASSWORD_RESET = 'EMAIL';

export enum PasswordResetTypes {
    EMAIL = 'EMAIL',
    SMS = 'SMS',
}

export const featureRouteMap: Partial<Record<Feature, string>> = {
    [Feature.PROMOTIONS]: 'promotions',
    [Feature.SHOP]: 'shop',
    [Feature.REWARDS]: 'rewards',
    [Feature.TOURNAMENTS]: 'tournaments',
    [Feature.DASHBOARD]: 'dashboard',
    [Feature.SPORTSBOOK]: 'sports',
    [Feature.BINGO_LOBBY]: 'bingo-lobby',
};

/**
 * Gets the enabled password reset features.
 */
export async function getPasswordResetFeatures() {
    const resetValues = (await window.queryBus.query<
        IFeatureQuery,
        IFeatureValue
    >(FEATURE_QUERY_VALUE, {
        slug: Feature.PASSWORD_RESET,
        defaultValue: DEFAULT_PASSWORD_RESET,
    }))!;

    if (resetValues.isApplicable && resetValues.value) {
        return (resetValues.value as string)
            .split(',')
            .map((value) => value.trim().toUpperCase())
            .filter((value) => {
                return !!PasswordResetTypes[value as PasswordResetTypes];
            });
    }

    return [PasswordResetTypes.EMAIL];
}

export function isHybridPnP() {
    return window.queryBus.query<string, boolean>(
        FEATURE_QUERY_ENABLED,
        Feature.HYBRID_PAY_AND_PLAY,
    );
}

export function isPurePnP() {
    return window.queryBus.query<string, boolean>(
        FEATURE_QUERY_ENABLED,
        Feature.PURE_PAY_AND_PLAY,
    );
}

export async function isBankIdAccountLinkingEnabled() {
    const isEnabled = await window.queryBus.query<string, boolean>(
        FEATURE_QUERY_ENABLED,
        Feature.BANK_ID_ACCOUNT_LINKING,
    );

    return isEnabled || (await isHybridPnP());
}

export function isSubdivisionRequired() {
    return window.queryBus.query<string, boolean>(
        FEATURE_QUERY_ENABLED,
        Feature.SUBDIVISION_REQUIRED,
    );
}

export function isTopNavEnabled() {
    return window.queryBus.query<string, boolean>(
        FEATURE_QUERY_ENABLED,
        Feature.TOP_NAVIGATION,
    );
}

export function isEnhancedCoversOnStaticPagesEnabled() {
    return window.queryBus.query<string, boolean>(
        FEATURE_QUERY_ENABLED,
        Feature.ENHANCED_COVERS_ON_STATIC_PAGES,
    );
}

export function getRoutePathForFeature(feature: Feature) {
    return featureRouteMap[feature] || undefined;
}
